var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterventionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.147,
    height: 20.373,
    viewBox: "0 0 18.147 20.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logic",
    transform: "translate(-1.603 0.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113028",
    "data-name": "Path 113028",
    d: "M19.414,11.731,18.1,8.836A8.136,8.136,0,0,0,12.513.654C4.369-1.939-1.647,8.244,4.532,14.128v5.493a.505.505,0,0,0,1.01,0v-5.7c-2.747-2.936-3.587-7.054-.715-10.3A7.062,7.062,0,0,1,17.091,8.949a.511.511,0,0,0,.045.209L18.5,12.153a.059.059,0,0,1-.024.075l-1.138.683a.5.5,0,0,0-.245.433V15.85a1.379,1.379,0,0,1-1.378,1.378H12.57a.505.505,0,0,0-.5.5v1.888a.505.505,0,0,0,1.01,0V18.24h2.634a2.391,2.391,0,0,0,2.39-2.39V13.629l.893-.539A1.067,1.067,0,0,0,19.414,11.731Z",
    transform: "translate(0 0)",
    fill: "#ffffff",
    stroke: "#2a3c76",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113029",
    "data-name": "Path 113029",
    d: "M15.8,12.536l.269-.467a1.313,1.313,0,0,0-.484-1.789.307.307,0,0,1-.112-.419,1.417,1.417,0,0,0,.588-1.919l-.278-.458A1.319,1.319,0,0,0,13.989,7a.505.505,0,0,0,.5.875.31.31,0,0,1,.422.117c.118.232.537.665.168.879a1.324,1.324,0,0,0,0,2.282c.364.206-.05.652-.162.883a.306.306,0,0,1-.412.124,1.311,1.311,0,0,0-1.792.475c-.259.278-.012.912-.487.953H11.7a.306.306,0,0,1-.306-.3,1.307,1.307,0,0,0-1.957-1.144.309.309,0,0,1-.421-.119c-.115-.232-.534-.665-.166-.876a1.314,1.314,0,0,0,.487-1.794c-.113-.365-.79-.467-.588-.9a.271.271,0,0,0,.016-.031L9.007,8a.305.305,0,0,1,.413-.115,1.314,1.314,0,0,0,1.8-.474c.2-.257.1-.617.257-.873.119-.17.588-.071.756-.1a.3.3,0,0,1,.3.306.505.505,0,0,0,1.01-.005,1.313,1.313,0,0,0-1.312-1.311h-.574c-.857.034-1.252.708-1.319,1.482a.3.3,0,0,1-.416.1,1.32,1.32,0,0,0-1.8.483l-.264.459a1.423,1.423,0,0,0,.6,1.913.305.305,0,0,1-.124.418,1.312,1.312,0,0,0-.474,1.794c0,.005.277.46.279.465a1.32,1.32,0,0,0,1.794.483.3.3,0,0,1,.446.267A1.32,1.32,0,0,0,11.7,14.6h.531a1.318,1.318,0,0,0,1.317-1.312.307.307,0,0,1,.469-.245A1.321,1.321,0,0,0,15.8,12.536Z",
    transform: "translate(-1.863 -1.696)",
    fill: "#ffffff",
    stroke: "#2a3c76",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113030",
    "data-name": "Path 113030",
    d: "M13.267,9.825a1.624,1.624,0,0,0,0,3.248A1.624,1.624,0,0,0,13.267,9.825Zm0,2.238h0a.614.614,0,0,1,0-1.228A.614.614,0,0,1,13.267,12.062Z",
    transform: "translate(-3.16 -3.132)",
    fill: "#ffffff",
    stroke: "#2a3c76",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterventionIcon);
export default __webpack_public_path__ + "static/media/intervention_icon.89e9a834f4902cd9b7c78c1e77f58e93.svg";
export { ForwardRef as ReactComponent };